import { render, staticRenderFns } from "./followUpAnalyse.vue?vue&type=template&id=05848f35&scoped=true&"
import script from "./followUpAnalyse.vue?vue&type=script&lang=js&"
export * from "./followUpAnalyse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05848f35",
  null
  
)

export default component.exports